import { OkpoModel } from '../../organizationsStore/organizationsStoreData';
import NsiStoreBase from '../nsiStoreBase';
import { NsiOkpoStoreService } from './nsiOkpoStore.service';

class NsiStationStore extends NsiStoreBase<OkpoModel, NsiOkpoStoreService> {
  service = new NsiOkpoStoreService();
}

export default new NsiStationStore();
